var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snackHeader"},[_c('ur-snackbar',{ref:"stackableSnackbar",attrs:{"stackable":"","closeBtn":"","duration":_vm.getSnackbar.duration},on:{"closed":_vm.removeMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }